angular.module('ikeweb.spike.step', ['ikeweb.routes']);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/step/step.module.js
// module id = 594
// module chunks = 0